export const TRACE = 1;
export const INFO = 2;
export const LOG = 3;
export const WARN = 4;
export const ERROR = 5;
export const MUTE = 6;

export const LEVELS = {
  info: INFO,
  log: LOG,
  trace: TRACE,
  warn: WARN,
  error: ERROR,
  mute: MUTE,
};
